import { useEffect, useState } from 'react';
import { NeedSituationEnum, Tariff, TariffService } from 'models/extension-generated';
import { useHealthInsuranceContext } from 'contexts/HealthInsuranceContext';

type UseTariffQuestionReturnType = {
  isLoading: boolean;
  tariffs: Array<Tariff>;
};

export const useTariffQuery = (): UseTariffQuestionReturnType => {
  const [isLoading, setIsLoading] = useState(false);
  const [tariffs, setTariffs] = useState<Array<Tariff>>([]);

  const { state } = useHealthInsuranceContext();

  const availableStartDate = state.model.applicationStart;

  // Make search query on filters change
  useEffect(() => {
    const fetchTariffQuestionsFn = async () => {
      setIsLoading(true);

      try {
        const response = await TariffService.getPublicTariffsByFilters({
          requestBody: {
            needSituation: NeedSituationEnum.ZVGKV_U
          }
        });
        setTariffs(response);
      } catch (error) {
        setTariffs([]);
      } finally {
        setIsLoading(false);
      }
    };

    if (availableStartDate) fetchTariffQuestionsFn();
  }, [availableStartDate]);

  return {
    isLoading,
    tariffs
  };
};
